module.exports = __webpack_public_path__ + "img/deal_room_black.b8221448.svg";